module.exports = __webpack_public_path__ + "static/img/snakes.a45d0b0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/snakes.gif
// module id = pe19
// module chunks = 1